import { Component, OnInit } from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';
import { ResourceModel } from '../../../../core/models/resources/resource.model';
import { Const, ResourceType } from '../../../../core/helpers/Const';
import { Observable } from 'rxjs';
import {NavigationService} from "../../../../service/services/misc/navigation/navigation.service";

@Component({
    selector: 'app-delete-confirmation-dialog',
    templateUrl: './has-resources-deletion-failed-dialog.component.html',
    styleUrls: ['./has-resources-deletion-failed-dialog.component.scss'],
    standalone: false
})
export class HasResourcesDeletionFailedDialogComponent implements OnInit {
    resource: ResourceModel;
    type: string;
    msg: string;
    title: string;
    errorMsg: string;
    Const = Const;
    deleteFunc: () => Observable<any>;
    loading = false;


    constructor(
		public dialogRef: DialogRef,
        private navigationService: NavigationService,
    ) {}

    FAILED_MSGS: { [key: string]: string } = {
        [ResourceType.FOLDER]: 'Cannot delete folder',
    };

    ngOnInit(): void {
        let data = this.dialogRef.data;
        this.type = 'warning';
        this.title = "Folder Deletion Failed";
        this.resource = data.resource;
        this.deleteFunc = data.deleteFunc;
    }

    async onGoToResources() {

        this.loading = true;
        this.dialogRef.loading(true);
        this.dialogRef.close(this.resource);
        const [org, ...pathList] = this.resource.path.substring(1).split('/');
        await this.navigationService.goToResource(Const.ALL_PROJECTS_PARAM, org, Const.FOLDERS, "/" + pathList.join('/'), `&uid=${this.resource.uid}`);
    }

    onSuccess() {
        this.dialogRef.close(this.resource);
    }

    validate() {
        return !this.loading;
    }
}
